function authenticationCodeInputsFor(input) {
  const wrapper = input.closest('.authentication-code-inputs');
  if (!wrapper) return [];

  return Array.from(wrapper.querySelectorAll('.authentication-code-input'));
}

document.addEventListener('paste', (event) => {
  if (!event.target.classList.contains('authentication-code-input')) return;

  const inputs = authenticationCodeInputsFor(event.target);
  const currentIndex = inputs.indexOf(event.target);
  const pastedCode = (event.clipboardData || window.clipboardData)
    .getData('text')
    .replace(/\D/g, '')
    .slice(0, inputs.length - currentIndex);

  if (!pastedCode) return;

  event.preventDefault();

  pastedCode.split('').forEach((digit, digitIndex) => {
    inputs[currentIndex + digitIndex].value = digit;
  });

  const nextInput = inputs[currentIndex + pastedCode.length] || inputs[inputs.length - 1];
  nextInput.focus();
});

document.addEventListener('input', (event) => {
  if (!event.target.classList.contains('authentication-code-input')) return;

  const inputs = authenticationCodeInputsFor(event.target);
  const currentIndex = inputs.indexOf(event.target);
  const digits = event.target.value.replace(/\D/g, '');

  event.target.value = digits.slice(0, 1);

  if (digits.length > 1) {
    digits.slice(1).split('').forEach((digit, digitIndex) => {
      const nextInput = inputs[currentIndex + digitIndex + 1];
      if (nextInput) nextInput.value = digit;
    });
  }

  const nextIndex = Math.min(currentIndex + digits.length, inputs.length - 1);
  if (event.target.value && inputs[nextIndex] && inputs[nextIndex] !== event.target) {
    inputs[nextIndex].focus();
  }
});

document.addEventListener('keydown', (event) => {
  if (!event.target.classList.contains('authentication-code-input')) return;

  const inputs = authenticationCodeInputsFor(event.target);
  const currentIndex = inputs.indexOf(event.target);

  if (event.key === 'Backspace' && !event.target.value && inputs[currentIndex - 1]) {
    inputs[currentIndex - 1].focus();
  }
});
